export default "__VITE_ASSET__Bs5tqL7z__"